import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import SectionRenderer from "../components/sections/SectionRenderer";
import {fetchPageByPath} from "../utils/PageUtils";

function DynamicPage() {
  const location = useLocation();

  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    setError("");

    fetchPageByPath(location.pathname)
      .then((data) => setPageData(data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [location.pathname]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Page not found</p>;
  if (!pageData) return null;

  const heroSection = pageData.sections.find(
    (section) => section.section_type === "hero"
  );

  const mainSections = pageData.sections.filter(
    (section) =>
      section.zone === "main" &&
      section.section_type !== "hero"
  );

  const sidebarSections = pageData.sections.filter(
    (section) => section.zone === "sidebar"
  );

  return (
    <div className="page-wrapper">
      {heroSection && <SectionRenderer section={heroSection} />}

      <div className="page-layout">
        <main className="main-content">
          {mainSections.map((section) => (
            <SectionRenderer key={section.id} section={section} />
          ))}
        </main>

        <aside className="sidebar" style={{marginTop:"45px"}}>
          {sidebarSections.map((section) => (
            <SectionRenderer key={section.id} section={section} />
          ))}
        </aside>
      </div>
    </div>
  );
}

export default DynamicPage;